import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { filter } from 'rxjs/operators';
import { AuthSessionFailureDialogComponent } from './auth-session-failure-dialog.component';
import { AuthSignInFailureDialogComponent } from './auth-signin-failure-dialog.component';
import { SessionFailure, SignIn, SignInFailure } from './core/auth.actions';

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    public dialog: MatDialog,
    private translate: TranslateService,
    private store: Store) {
    this.actions$
      .pipe(ofActionDispatched(SessionFailure))
      .subscribe(() => {
        this.dialog
          .open(
            AuthSessionFailureDialogComponent,
            {
              data: {
                title: this.translate.instant('error.auth.sessionFailure.title'),
                message: this.translate.instant('error.auth.sessionFailure.message'),
                okText: this.translate.instant('error.auth.sessionFailure.ok'),
                cancelText: this.translate.instant('error.auth.sessionFailure.cancel'),
              },
              minWidth: '400px',
              width: '400px',
            },
          )
          .afterClosed()
          .pipe(filter(ok => !!ok))
          .subscribe(() => this.store.dispatch(new SignIn()));
      });

    this.actions$
      .pipe(ofActionDispatched(SignInFailure))
      .subscribe(x => {
        console.log('SignInFailure: ', x);
        this.dialog
          .open(
            AuthSignInFailureDialogComponent,
            {
              data: {
                title: this.translate.instant('error.auth.signInFailure.title'),
                message: x.error,
                okText: this.translate.instant('error.auth.signInFailure.ok'),
                cancelText: this.translate.instant('error.auth.signInFailure.cancel'),
              },
              width: '400px',
            },
          )
          .afterClosed()
          .pipe(filter(ok => !!ok))
          .subscribe();
      });
  }
}
